module.exports = __webpack_public_path__ + "static/media/375.15ad9327.webp";